<script
    src="../../../../../../../AppData/Local/Temp/Rar$DRa14036.14120/src/app/helper/alertTimer/alert-timer.service.ts"
></script>
<template>
  <div>
    <div class="card">
      <validation-observer ref="simpleRules">
        <b-form>
          <div class="card-header" />
          <div class="card-body">
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label for="name">Name</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Name"
                    rules="required"
                  >
                    <b-form-input
                      id="name"
                      v-model="editedProject.name"
                      name="name"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="name">Budget</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Budget"
                    rules="required"
                  >
                    <b-form-input
                      id="name"
                      type="number"
                      v-model="editedProject.budget"
                      name="name"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="projectStatus">Status</label>
                  <validation-provider
                    #default="{ errors }"
                    name="project Status"
                    rules="required"
                  >

                    <v-select
                      id="projectStatus"
                      v-model="editedProject.projectStatus"
                      :class="errors.length > 0 ? 'error-border':null"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="projectAttributes.projectStatuses"
                      :reduce="name => name.id"
                      label="name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label for="country">Country</label>
                  <validation-provider
                      #default="{ errors }"
                      name="country"
                      rules="required"
                  >
                    <v-select
                        id="country"
                        v-model="editedProject.country"
                        :class="errors.length > 0 ? 'error-border':null"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="projectAttributes.countries"
                        :reduce="name => name.id"
                        label="name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="city">City</label>
                  <validation-provider
                      #default="{ errors }"
                      name="city"
                      rules="required"
                  >
                    <v-select
                        id="city"
                        v-model="editedProject.city"
                        :class="errors.length > 0 ? 'error-border':null"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="getCountryCities"
                        :reduce="name => name.id"
                        label="name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="type">Area</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Area"
                    rules="required"
                  >
                    <v-select
                      id="areas"
                      v-model="editedProject.area"
                      :class="errors.length > 0 ? 'error-border':null"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="getCityArea"
                      :reduce="name => name.id"
                      label="name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label for="name">Project Reference</label>
                  <validation-provider
                      #default="{ errors }"
                      name="Reference"
                      rules="required"
                  >
                    <b-form-input
                        id="name"
                        v-model="editedProject.projectReference"
                        name="projectReference"
                        :state="errors.length > 0 ? false:null"
                        placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="projectType">Type</label>
                  <validation-provider
                      #default="{ errors }"
                      name="project Type"
                      rules="required"
                  >

                    <v-select
                        id="projectType"
                        v-model="editedProject.projectType"
                        :class="errors.length > 0 ? 'error-border':null"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="projectAttributes.projectTypes"
                        :reduce="name => name.id"
                        label="name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="type">Client</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Client"
                    rules="required"
                  >
                    <v-select
                      id="client"
                      v-model="editedProject.userId"
                      :class="errors.length > 0 ? 'error-border':null"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="projectAttributes.clients"
                      :reduce="full_name => full_name.id"
                      label="full_name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label for="signingDate">Signing Date</label>
                  <validation-provider
                      #default="{ errors }"
                      name="signingDate"
                      rules="required"
                  >
                    <template>
                      <b-form-datepicker
                          id="signingDate"
                          v-model="editedProject.signingDate"
                          :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                          menu-class="w-100"
                          calendar-width="100%"
                      />
                    </template>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="initiatedDate">Initiated Date</label>
                  <validation-provider
                      #default="{ errors }"
                      name="initiatedDate"
                      rules="required"
                  >
                    <template>
                      <b-form-datepicker
                          id="initiatedDate"
                          v-model="editedProject.initiatedDate"
                          :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                          menu-class="w-100"
                          calendar-width="100%"
                      />
                    </template>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="name">Longitude</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Longitude"
                    rules="required"
                  >
                    <b-form-input
                      id="name"
                      type="number"
                      v-model="editedProject.lon"
                      name="name"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label for="name">Latitude</label>
                  <validation-provider
                      #default="{ errors }"
                      name="Latitude"
                      rules="required"
                  >
                    <b-form-input
                        id="name"
                        type="number"
                        v-model="editedProject.lat"
                        name="Latitude"
                        :state="errors.length > 0 ? false:null"
                        placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="projectStatus">Currency</label>
                  <validation-provider
                      #default="{ errors }"
                      name="currency"
                      rules="required"
                  >

                    <v-select
                        id="currency"
                        v-model="editedProject.currency"
                        :class="errors.length > 0 ? 'error-border':null"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="[{name: 'EID', id: 'EID'}]"
                        :reduce="name => name.id"
                        label="name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="name">Villa Number</label>
                  <validation-provider
                    #default="{ errors }"
                    name="villaNumber"
                    rules="required"
                  >
                    <b-form-input
                      id="villaNumber"
                      v-model="editedProject.villaNumber"
                      type="text"
                      name="villaNumber"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="name">Plot Number</label>
                  <validation-provider
                    #default="{ errors }"
                    name="plotNumber"
                    rules="required"
                  >
                    <b-form-input
                      id="plotNumber"
                      v-model="editedProject.plotNumber"
                      type="text"
                      name="villaNumber"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="name">Street Number</label>
                  <validation-provider
                    #default="{ errors }"
                    name="streetNumber"
                    rules="required"
                  >
                    <b-form-input
                      id="streetNumber"
                      v-model="editedProject.streetNumber"
                      type="text"
                      name="villaNumber"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <label for="type">Approved Layout From Consultant</label>
                  <a
                      v-if="prevApprovedLayoutFromConsultant!==null"
                      :href="prevApprovedLayoutFromConsultant !==null && prevApprovedLayoutFromConsultant"
                      target="_blank"
                  ><small style=" float: right;">View Old File?</small>
                  </a>
                  <validation-provider
                    #default="{ errors }"
                    name="approvedLayoutFromConsultant"
                    rules=""
                  >
                    <b-form-file
                      v-model="editedProject.approvedLayoutFromConsultant"
                      :file-name-formatter="formatNames"
                      accept=".pdf"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="type">Title Deed</label>
                  <a
                      v-if="prevTitleDeed!==null"
                      :href="prevTitleDeed !==null && prevTitleDeed"
                      target="_blank"
                  ><small style=" float: right;">View Old File?</small>
                  </a>
                  <validation-provider
                    #default="{ errors }"
                    name="titleDeed"
                    rules=""
                  >
                    <b-form-file
                      v-model="editedProject.titleDeed"
                      :file-name-formatter="formatNames"
                      accept=".pdf"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label for="image">Initial Site Images</label>
                  <validation-provider
                    #default="{ errors }"
                    name="initialSiteImages"
                    rules=""
                  >
                    <vue-dropzone
                      id="image"
                      ref="initialSiteImagesRef"
                      name="image"
                      :options="dropzoneOptions"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div
            class="card-footer"
            style="display: flex; justify-content: end;"
          >
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="validationForm"
            >
              Submit
            </button>
          </div>
        </b-form>
      </validation-observer>
    </div>

  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea, BFormDatepicker, BFormFile

} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vSelect from 'vue-select'
import vue2Dropzone from 'vue2-dropzone'
import { codeMultiple, codeBasic } from './code'
import FormTextAreaDefault from '../../../shared/form-textarea/FormTextAreaDefault.vue'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import clientService from '@/services/clientService'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import projectService from '../../../services/projectService'
import companyService from '@/services/companyService'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,

    BFormFile,
    BFormDatepicker,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    FormTextAreaDefault,
    vSelect,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      prevApprovedLayoutFromConsultant: null,
      prevTitleDeed: null,
      editedProject: {

      },
      projectAttributes: [],
      prevInitialSiteImages: [],
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        dictRemoveFile: 'Remove',
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
      },
    }
  },
  mounted() {
    this.getProjectAttribute()
    this.getProject()
    this.$watch(() => this.prevInitialSiteImages, val => {
      for (let i = 0; i < val.length; i++) {
        this.$refs.initialSiteImagesRef.manuallyAddFile(val[i].file, val[i].url)
      }
    })
    this.$watch(() => this.prevApprovedLayoutFromConsultant, file1 => {
      this.prevApprovedLayoutFromConsultant = file1
    })
    this.$watch(() => this.prevTitleDeed, file2 => {
      this.prevTitleDeed = file2
    })
  },
  computed: {
    getCountryCities() {
      return (this.projectAttributes.cities ?? []).filter(city => this.editedProject.country == city.country_id);
    },
    getCityArea() {
      return (this.projectAttributes.areas ?? []).filter(area => this.editedProject.city == area.city_id);
    }
  },
  methods: {
    getProject(){
      projectService.project(this.$route.params.id).then(response => {
        var updatedProject = response.data.data
        this.prevInitialSiteImages = updatedProject.initialSiteImages
        this.prevApprovedLayoutFromConsultant = updatedProject.approvedLayoutFromConsultant.url
        this.prevTitleDeed = updatedProject.titleDeed.url
        this.editedProject= {
          id: updatedProject.id,
          userId: updatedProject.user.id,
          projectType: updatedProject.projectType.id,
          area: updatedProject.area.id,
          city: updatedProject.area.city.id,
          country: updatedProject.area.city.country.id,
          projectStatus: updatedProject.projectStatus.id,
          projectReference:  updatedProject.projectReference,
          name: updatedProject.name,
          budget: parseFloat(updatedProject.budget),
          signingDate: updatedProject.signingDate,
          initiatedDate: updatedProject.initiatedDate,
          lat: updatedProject.lat,
          lon: updatedProject.lon,
          villaNumber: updatedProject.villaNumber,
          plotNumber: updatedProject.plotNumber,
          streetNumber: updatedProject.streetNumber,
          titleDeed: null,
          approvedLayoutFromConsultant: null,
          remained: [],
          uploaded: [],
          currency: updatedProject.currency
          // initialSiteImages: updatedProject.initialSiteImages,
        }

      })
    },
    getProjectAttribute(withLoading = true) {
      projectService.attributes().then(response => {
        this.projectAttributes = response.data.data
      })
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name
      }
      return `${files.length} files selected`
    },
    validationForm() {
      this.$refs.simpleRules.validate()
          .then(success => {
            if (success) {
              // this.editedProject.initialSiteImages = this.$refs.createProjectRef.getAcceptedFiles()
              this.editedProject.uploaded = this.$refs.initialSiteImagesRef.getAcceptedFiles() ?? []
              const arr = this.$refs.initialSiteImagesRef.getRejectedFiles().map(el => el.id) ?? []
              this.editedProject.remained = arr
              var convertedBudget = this.editedProject.budget
              this.editedProject.budget= parseFloat(convertedBudget)

              projectService.put(this.editedProject)
                  .then(response => {
                    if(response && response.status === 200){
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: 'Success',
                          icon: 'CheckIcon',
                          variant: 'success',
                          text: `Project Is Updated Successfully !`,
                        },
                      })
                    }
                    this.$router.push({ name: 'projects' })

                    this.loading = false
                  })
            }
          }).catch(function (error) {
        return Promise.reject(error)
      })
    },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

label {
  font-weight: bold;
}
.error-border{
  border: 1px solid #ea5455!important;
}
</style>
